module.exports = __webpack_public_path__ + "static/img/5.d0708f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/5.png
// module id = Eg4K
// module chunks = 0